import { currencyColumn, dateColumn, numberColumn, primaryRelationshipColumn, relationshipColumn, tagColumn, textColumn } from "@api/schema/columnHelpers";
import { objectDefinition } from "@api/schema/supportedObjects";
import RapidReinvestmentSection from "./RapidReinvestmentSection";
import { forwardRef } from "react";

const relationshipType = 'property';
const {pluralName, color, endpoint} = objectDefinition(relationshipType);
const columns = [
    primaryRelationshipColumn({column: 'id', endpoint, label: 'Address', required: true}),
    tagColumn({column: 'units', label: 'Unit Name(s)', required: true}),
    dateColumn({label: 'Date Built', required: true}),
];


const NewResidentialUnits = forwardRef(function NewResidentialUnits(props, ref) {
    return (
        <RapidReinvestmentSection
            type={relationshipType}
            columns={columns}
            {...props}
            ref={ref}
        />
    )
});

export {NewResidentialUnits};
